export enum NavigationPageType {
  CHANGELOG = 'changelog',
  CUSTOM_PAGE = 'custompage',
  DISCUSSIONS = 'discuss',
  GUIDES = 'docs',
  HOME = 'home',
  RECIPES = 'recipes',
  API_REFERENCE = 'reference',
  SEARCH_BOX = 'search',
  LINK_URL = 'url',
  USER_CONTROLS = 'user',
}
